var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, } from '@servicetitan/design-system';
import * as Styles from './select-cell.module.css';
export const SelectCell = (_a) => {
    var { selectionChange, control: Control = Checkbox } = _a, props = __rest(_a, ["selectionChange", "control"]);
    const onChange = (_0, _1, event) => {
        if (!selectionChange) {
            return;
        }
        selectionChange({ syntheticEvent: event });
    };
    return _jsx(Control, Object.assign({ className: Styles.checkbox, onChange: onChange }, props));
};
export const SelectColumnCell = (props) => {
    if (props.rowType === 'groupHeader') {
        return null;
    }
    if (props.rowType === 'groupFooter') {
        return _jsx("td", {});
    }
    return (_jsx("td", Object.assign({ style: props.style, className: props.className }, { children: _jsx(SelectCell, { checked: props.dataItem.selected, disabled: !props.isRowSelectable, selectionChange: props.selectionChange, indeterminate: props.dataItem.indeterminate, control: props.control }) })));
};
export const SelectHeaderCell = (props) => (_jsx(SelectCell, { checked: props.selectionValue, indeterminate: props.isSomeRowsSelected, selectionChange: props.selectionChange, control: props.control }));
//# sourceMappingURL=select-cell.js.map